import Card from "@pathwright/ui/src/components/card/Card"
import {
  FeatureAction,
  FeatureKey
} from "@pathwright/graphql-client/src/generated"
import FeatureBlockContainer from "../../feature/block/FeatureBlockContainer"
import HomeScreenFeatureBlockContainer from "../../feature/block/HomeScreenFeatureBlockContainer"
import { Container as FeatureBlockListContainer } from "../../feature/block/FeatureBlockList"
import useLabFeatureVisibility from "./useLabFeatureVisibility"

const ManageLabFeatures = ({ card }: { card: any }) => {
  const visibility = useLabFeatureVisibility()

  return (
    <Card card={card} title="Lab Features">
      <FeatureBlockListContainer>
        {visibility.home && (
          <HomeScreenFeatureBlockContainer to={`${card.path}home/`} />
        )}
        {visibility.coverPages && (
          <FeatureBlockContainer
            featureKey={FeatureKey.LibraryCoverPages}
            featureAction={FeatureAction.CoverPagesView}
            context={null}
            to={`${card.path}cover-pages/`}
          />
        )}
      </FeatureBlockListContainer>
    </Card>
  )
}

export default ManageLabFeatures
